import { render, staticRenderFns } from "./SelfDids.vue?vue&type=template&id=92d3bbac&scoped=true&"
import script from "./SelfDids.vue?vue&type=script&lang=js&"
export * from "./SelfDids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3bbac",
  null
  
)

export default component.exports